import { render, staticRenderFns } from "./Member.vue?vue&type=template&id=48948bf8&scoped=true"
import script from "./Member.vue?vue&type=script&lang=ts"
export * from "./Member.vue?vue&type=script&lang=ts"
import style0 from "./Member.vue?vue&type=style&index=0&id=48948bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48948bf8",
  null
  
)

export default component.exports